
<template>
    <detail-header
        pretitle="Sandbox"
        :title="sandbox? sandbox.name : '&nbsp;'"
        :editable="true"
        :editMode="editMode"
        :editRoles="editRoles"
        @editClick="onEditClick"
        @deleteClick="onDeleteClick"
        @saveClick="onSaveClick"
        @cancelClick="onCancelClick"
        @closeClick="$router.push(`/${$store.state.currentClient.cid}/amdp/sandboxes`)"
    />

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <div v-if="error" class="alert alert-danger" role="alert">
                            {{error}}
                </div>
                <div v-if="successMessage" class="alert alert-success" role="alert">
                    {{successMessage}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">                
                <div v-if="sandbox" class="card">
                    <div class="card-body">
                        <form-fields :fields="sandboxFields" v-model="sandbox" />
                    </div>
                </div>
                <div v-if="loading" class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div  class="card">
                    <div class="card-body" v-if="sandbox">
                        <h4>Users List</h4>
                        <div v-if="editMode" class="input-group mb-3" >
                            <input type="text" class="form-control" v-model="inputVal" placeholder="Users Email" aria-label="Users Email" aria-describedby="basic-addon2">
                            <div class="input-group-append">
                                <button  @click="onAddSandboxUser" class="btn btn-primary" type="button">Add User</button>
                            </div>
                        </div> 
                        <list-group v-if="userList" :editMode="editMode" :title="'Users List'" :list="userList"  @deleteBtnClick="onDeleteSandboxUser"></list-group>
                    </div>

                </div>                
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "../../components/DetailHeader.vue";
import FormFields from "../../components/FormFields.vue";
import ListGroup from '../../components/ListGroup.vue';
import getSandboxFields from "../../utils/field-constants/sandboxFields"
import { mapActions, mapState } from "vuex";
export default {
    name: "SandboxDetail",
    components: { DetailHeader,  FormFields, ListGroup },
    data() {        
        return {
            editMode: false,
            sandbox: {},
            sandboxFields: [],
            snapshot: null,
            error: "",
            successMessage: "",
            userList: [],
            inputVal: "",
            loading: false,
            sandboxJobKinds:["TRANSFORM"],
            editRoles: [1, 1.5], // aqfer_amdin and aqfer_manager only can edit sandboxes
        };
    },
    async beforeMount() {
        this.fetchSandbox();
        this.sandboxFields = getSandboxFields();  
        await this.fetchJobKinds();     
        this.sandboxFields = this.sandboxFields.map(item => {
            item.editable = false;
            if(item.name =="enabled_job_kinds"){
                item.options= this.jobKindOption
            }
            if(item.name =="override_access_expires_after"){
                item.visible = this.$store.state.sandbox.devSandboxes.map(sandbox => sandbox.name).includes(this.$route.params.id);
            }
            return item;
        });
    },
    computed: { 
        ...mapState({
            jobKinds: (state) => state.amdp.jobKinds,
        }),
        jobKindOption(){
            let jobKindOptions = this.jobKinds.map((jobKind)=> {
                let name = jobKind.name.charAt(0).toUpperCase() + jobKind.name.slice(1);
                this.sandboxJobKinds.push(name.toUpperCase());
                return { label:name, value: name.toUpperCase() } 
            });
            //there is issue, till it getting resolved need this TRANSFORM hardcoded - aMDP team
            jobKindOptions.push({label:"transform",value:"TRANSFORM"});
            return jobKindOptions;
        }
    }, 
    watch:{
        "sandbox.all_job_kind":{
            handler( newVal){
                if(newVal !=="" && Array.isArray(newVal)){
                    if (newVal.toString()=== "all"){
                        this.sandbox.enabled_job_kinds= this.sandboxJobKinds;
                    }else{
                        this.sandbox.enabled_job_kinds= [];
                    }
                }
            }
        },
        "sandbox.enabled_job_kinds":{
            handler( newVal){
                if (newVal.length === this.sandboxJobKinds.length){
                    this.sandbox.all_job_kind=["all"];
                }else
                    this.sandbox.all_job_kind=""; //to denote the change is not from checkbox, else deselect all will happen
            }
        }
    },
    methods: {
        ...mapActions({
            readSandbox: "sandbox/readSandbox",
            updateSandbox: "sandbox/updateSandbox",
            deleteSandbox: "sandbox/deleteSandbox",
            readSandboxUserList: "sandbox/fetchSandboxUsers",
            addSandboxUser:"sandbox/addSandboxUser",
            deleteSandboxUser: "sandbox/deleteSandboxUser",
            showModal: "showModal",
            fetchJobKinds: "amdp/fetchJobKinds",
        }),
        setEditMode(mode) {
            let self = this;
            this.editMode = mode;
            this.successMessage = null;
            this.error = null;
            //Make primary fields non editable.
            this.sandboxFields = this.sandboxFields.map(item => {
                             item.editable = (item.key)?false:self.editMode; 
                             return item;
                        });
        },
        async fetchSandbox() {
            this.loading = true;
            let response={};
          
            try {
                response = await this.readSandbox(this.$route.params.id);
            } catch (error) {
                if (error.response && error.response.data && error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                return;
            } finally {
                this.loading = false;
            }
            
            this.sandbox = await response.data;
            if(!this.sandbox)
                this.error = "Sandbox details not found!"
            this.snapshot = {...this.sandbox}
            this.fetchSandboxUserList();
        },
        async fetchSandboxUserList() {
            let response;
            try {
                response = await this.readSandboxUserList(this.sandbox.name);
                this.userList = response.data;
            } catch (error) {
                if (error.response.data && error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                return;
            }
            
        },

        async onAddSandboxUser() {
            const userEmail =  this.inputVal;
            let toastoptions
            try {
                const response = await this.addSandboxUser({"sandboxName":this.sandbox.name, "email":userEmail, payload:{access_level: "PROMOTER"}});
                this.fetchSandboxUserList();
                toastoptions = {
                        message: "Sandbox User added successfully.",
                        type: "success"
                    }
            } catch (error) {
                let errorMessage = "";
                if (error.response.data.error)
                    errorMessage = error.response.data.error;
                else errorMessage = error.message;
                toastoptions = {
                        message: errorMessage || "Something went wrong when adding user. Please contact support.",
                        type: "error"
                    }
                
            }finally{
                this.$store.dispatch('addToast', toastoptions);
            }

        },
        async onDeleteSandboxUser(user) {
            let toastoptions
            try {
                const response = await this.deleteSandboxUser({"sandboxName":this.sandbox.name, "email":user.email});
                this.fetchSandboxUserList();
                toastoptions = {
                        message: "Sandbox User deleted successfully.",
                        type: "success"
                    }
            } catch (error) {
                let errorMessage = "";
                if (error.response.data.error)
                    errorMessage = error.response.data.error;
                else errorMessage = error.message;
                toastoptions = {
                        message: errorMessage || "Something went wrong when deleting user. Please contact support.",
                        type: "error"
                    }
                this.$store.dispatch('addToast', toastoptions);
            }finally{
                this.$store.dispatch('addToast', toastoptions);
            }
        },
        onCancelClick() {
            this.setEditMode(false)
            this.sandbox = {...this.snapshot}
            this.error = null
        },
        onEditClick() {
            this.setEditMode(true)
        },
        onDeleteClick() {
            const self = this;
            this.showModal({ 
                component: "confirm", data: {
                    title: 'Delete Sandbox',
                    message: `Are you sure you want to delete ${this.sandbox.name}?`,
                    async confirm() {
                        try {
                            const response = await self.deleteSandbox(self.sandbox.name);
                            self.$router.push(`/${self.$store.state.currentClient.cid}/amdp/sandboxes`)
                            return response;
                        } catch (error) {
                            if (error.response.data.error)
                                self.error = error.response.data.error;
                            else self.error = error.message;
                            return;
                        }
                    },
                } 
            });
        },
        toUTCISOString(rfcDateString) {
            const localDate = new Date(rfcDateString.replace(' ', 'T')); // Replace space with T so JS parses it reliably
            return localDate.toISOString().split('.')[0] + 'Z'; // Convert to ISO (always UTC)
        },
        async onSaveClick() {
            try {
                let sandbox = JSON.parse(JSON.stringify(this.sandbox));
                if(sandbox?.all_job_kind.toString() === "all"){
                    sandbox.enabled_job_kinds =['*', 'TRANSFORM'];
                }
                delete sandbox.all_job_kind;
                if (sandbox?.override_access_expires_after){
                    sandbox.override_access_expires_after = this.toUTCISOString(sandbox.override_access_expires_after);
                }
                const response = await this.updateSandbox(sandbox);
                this.setEditMode(false);
                this.snapshot = {...this.sandbox}
                this.successMessage = 'Sandbox updated successfully.'
            } catch (error) {
                if (error.response.data.error)
                    self.error = error.response.data.error;
                else self.error = error.message;
            }
            
        }
    },
};
</script>

<style scoped>
.input-group>.input-group-append>.btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
</style>